export default __webpack_public_path__ + "static/media/brandImg.6787f7d9.png";